



























import { defineComponent } from '@vue/composition-api';

import BrowseDatasetMenu from './BrowseDatasetMenu.vue';
import GenerateDatasetMenu from './GenerateDatasetMenu.vue';
import ManageVideoFilesMenu from './ManageVideoFilesMenu.vue';
import UploadVideoFileMenu from './UploadVideoFileMenu.vue';
import { generateDatasetMenu, uploadVideoFileMenu, uploadDialogWidth, manageVideoFilesMenu } from '../state';

export default defineComponent({
  name: 'File',
  components: {
    BrowseDatasetMenu,
    GenerateDatasetMenu,
    ManageVideoFilesMenu,
    UploadVideoFileMenu,
  },
  setup() {
    return { generateDatasetMenu, uploadVideoFileMenu, uploadDialogWidth, manageVideoFilesMenu };
  },
});
